import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import WaitlistWizard from "./WaitlistWizard";

/**
 * Updated WaitlistForm — quick email entry that launches the full 6-step
 * onboarding wizard. Preserves the existing visual surface entirely.
 */
const WaitlistForm = ({ size = "lg", testidPrefix = "waitlist", className = "" }) => {
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const isLg = size === "lg";

  const submit = (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) return;
    setOpen(true);
  };

  return (
    <>
      <form
        onSubmit={submit}
        className={`flex flex-col sm:flex-row gap-2 ${className}`}
        data-testid={`${testidPrefix}-form`}
      >
        <div className="relative flex-1">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className={`w-full ${isLg ? "h-14 text-base px-5" : "h-12 text-sm px-4"} bg-[#0A0A0A] border border-white/10 rounded-full text-white placeholder:text-white/30 focus:outline-none focus:border-[#00FF88]/50 focus:ring-2 focus:ring-[#00FF88]/20 transition-all`}
            data-testid={`${testidPrefix}-email-input`}
          />
        </div>
        <button
          type="submit"
          className={`inline-flex items-center justify-center gap-2 ${isLg ? "h-14 px-7 text-base" : "h-12 px-6 text-sm"} bg-[#00FF88] text-black font-bold rounded-full btn-glow`}
          data-testid={`${testidPrefix}-submit-button`}
        >
          Join Waitlist
          <ArrowRight className="w-4 h-4" />
        </button>
      </form>
      <WaitlistWizard open={open} onClose={() => setOpen(false)} prefillEmail={email} />
    </>
  );
};

export default WaitlistForm;
